import { NavLink } from "react-router-dom";
import logo from "../assets/regulate-logo.svg";
import upRightArrow from "../assets/up-right-arrow-white.svg";
import MobilMenuDrawer from "./MobilMenuDrawer";

const Navbar = () => {
  return (
    <div className="d-flex justify-content-center w-100">
      <nav className="navbar navbar-expand-lg commonInlinePadding section-container w-100">
        <div className="container-fluid d-flex justify-content-between">
          <div>
            <NavLink className="navbar-brand" to="/">
              <img src={logo} style={{ width: "7.92338rem" }} alt="Logo" />
            </NavLink>
          </div>

          <div className=" d-flex align-items-center gap-3 navBarItems">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              aria-current="page"
              to="/services"
            >
              Services
            </NavLink>

            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              to="/media"
            >
              Media
            </NavLink>

            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              to="/faqs"
            >
              FAQs
            </NavLink>

            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              to="/contact"
            >
              Contact
            </NavLink>

            <NavLink
              className={() =>
                "button-text nav-button loginButtonNav"
              }
              to="https://app.regulatecpg.com/login/"
              target="_blank"
            >
              Login
            </NavLink>
          </div>

          <MobilMenuDrawer />

          <button
            className="btn btn-primary navBarItems"
            onClick={() =>
              window.open(
                "https://connect.regulatecpg.com/regulate-book-a-demo",
                "_blank"
              )
            }
          >
            Book Demo{" "}
            <div className="btn-icon-container">
              <img src={upRightArrow} alt="Arrow" />
            </div>
          </button>
        </div>
      </nav>
    </div>

  );
};

export default Navbar;
